import { FormContextValues } from '@dreryk/react-common';
import { RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { preInterviewSettingsTranslationKeys } from '../../../../translations';

import {
   NOTIFICATION_CHANNELS,
   NotificationChannel,
   NotificationChannelFieldFormBeanPart,
} from './NotificationChannelField.types';

const t = preInterviewSettingsTranslationKeys;

const radioGroupItems: RadioGroupItem<NotificationChannel>[] = NOTIFICATION_CHANNELS.map((channel) => ({
   id: channel,
   label: t.channelMap[channel],
}));

type NotificationChannelFieldProps = Readonly<
   Pick<FormContextValues<NotificationChannelFieldFormBeanPart>, 'register'> & { disabled: boolean }
>;

export const NotificationChannelField = (props: NotificationChannelFieldProps): JSX.Element => {
   return (
      <RadioGroup<NotificationChannel>
         testId={'notificationChannel'}
         label={t.notificationChannel}
         controller={props.register('preInterviewNotificationChannel')}
         items={radioGroupItems}
         disabled={props.disabled}
         horizontal
      />
   );
};
